// Server-clock estimate for countdowns against server-issued epochs (e.g. the CTF turn deadline).
//
// A deadline stamped by the server compared with the browser's Date.now() is off by however far the
// laptop clock is skewed: a clock 60 s fast showed a 90 s turn as 30 s, or 0 straight away. The API is
// served from the same origin, so its HTTP `Date` header is readable; noteServerDate() records the
// offset from it and serverNow() applies it.
//
// `Date` has 1 s resolution, so the estimate is only good to about a second (plus half the round
// trip). An offset under SKEW_THRESHOLD_MS is treated as noise and ignored, so a correctly-synced
// clock is never nudged by it. Without any reading (header missing, cross-origin, tests) serverNow()
// is plain Date.now().
const SKEW_THRESHOLD_MS = 2000

let offsetMs = 0

export const noteServerDate = (response, { requestStartedAt, now = Date.now() } = {}) => {
  const header = response?.headers?.get?.("date")
  if (!header) return
  const serverMs = Date.parse(header)
  if (!Number.isFinite(serverMs)) return
  // The header is truncated to the second: +500 ms is the expected server time at its midpoint, compared
  // against the midpoint of the request on the local clock.
  const localMidpoint = Number.isFinite(requestStartedAt) ? (requestStartedAt + now) / 2 : now
  const measured = serverMs + 500 - localMidpoint
  offsetMs = Math.abs(measured) >= SKEW_THRESHOLD_MS ? measured : 0
}

export const serverNow = () => Date.now() + offsetMs

export const resetServerClockForTests = () => {
  offsetMs = 0
}
